import { Injectable } from '@angular/core';
import { timestamp } from 'rxjs/operators';
import { Roles } from '../_models/roles.type.model';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  statuses: any = {
    // USERS
    registration_pending: "In attesa di conferma",
    confirmed: "Confermato",
    qualification_pending: "In attesa di qualifica",
    qualified: "Qualificato",
    disabled: "Disabilitato",
    deleted: "Cancellato",
    active: "Dipendente Attivo",
    // DOCS
    approved: "Approvato",
    refused: "Rifiutato",
    modified: "Modificato",
    inserted: "Inserito",
    // CLASSIFIEDS
    available: "Disponibile",
    booked: "Prenotato",
    expired: "Scaduto",
    // deleted: "Cancellato",
  }

  monthNames: Array<string> = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

  daysOfWeekNames: Array<string> = [
    'Lunedi',
    'Martedi',
    'Mercoledi',
    'Giovedi',
    'Venerdi',
    'Sabato',
    'Domenica',
  ];

  mandatoryDocsEnum: Array<any> = [
    {title: "Obbligatorio", value: true},
    {title: "Facoltativo", value: false}
  ];

  constructor(private authService: AuthService,) { }

  deepClone(obj: any): any {
    // Clona un oggetto JSON
    let deepClone = JSON.parse(JSON.stringify(obj));
    return deepClone;
  }

  formatBirthDate(str: string): string {
    var d = new Date(str),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
  }

  async canAccessAdvancedFunctionalities() {
    let role = await this.authService.getUserRole();
    if ( role == Roles.Admin)
      return true
    // Se l'employee sta entrando nel sito, vuol dire che il manager è stato qualificato e che puo creare account dipendente.
    // Quindi anche l'employee se esiste ha sempre accesso a tutte le funzionalita
    if ( role == Roles.Employee)
      return true
    // Il manager puo accedere alle funzionalita del sito solo quando è qualificato
    if ( role == Roles.Manager) {
      let status = await this.authService.getUserStatus();
    }
    return false;
  }

  partnerTypesToStringArray(listt: Array<any>): Array<string> {
    let result: any[] = [];
    listt.forEach(element => {
      result.push( element.partner_type_value.value);
    });
    return result;
  }

  prettyPrintAddress(addressObj: any, short?: boolean) {
    let stringAddress = "";
    stringAddress += addressObj.street + " " + addressObj.house_number + ", " + addressObj.city + " (" + addressObj.province + ")";
    if ( short )
      return stringAddress;
    stringAddress += ", " + addressObj.zip + ", " + addressObj.country;
    return stringAddress;
  }

  formatFullDate(str: string): string {
    var d = new Date(str),
    hours = '' + (d.getHours()),
    minutes = '' + (d.getMinutes()),
    // seconds = '' + (d.getSeconds()),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = '' + d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
    if (minutes.length < 2)
      minutes = '0' + minutes;
    if (hours.length < 2)
      hours = '0' + hours;
    // if (seconds.length < 2)
    //   seconds = '0' + seconds;

    const date = [day, month, year].join('/');
    const time = [hours, minutes].join(':');
    return date + " " + time;
  }

  getTimeFromISOString(str: string): string {
    const dateObj = new Date(str);
    let h = dateObj.getHours().toString();
    let m = dateObj.getMinutes().toString();

    if (h.length < 2)
      h = '0' + h;
    if (m.length < 2)
      m = '0' + m;

    return h + ":" + m;
  }

  prettyPrintStatus(status: string) {;
    return this.statuses[status];
  }

  getDateFromISOString(str: string): string {
    const dateObj = new Date(str);
    let d = dateObj.getDate().toString();
    let m = (dateObj.getMonth() +1).toString();
    let y = dateObj.getFullYear().toString();

    if (d.length < 2)
      d = '0' + d;
    if (m.length < 2)
      m = '0' + m;
    if (y.length < 2)
      y = '0' + y;

    return d + "-" + m + "-" + y;
  }

  getDateFromPeriod(period: string): string {

    var now = new Date();
    let timestamp = "";

    switch(period) {
      case "settimana": {
        // Calcolo data inizio settimana
        now.setDate( now.getDate() - (now.getDay() -1) );
        timestamp = (new Date(now.getFullYear(), now.getMonth(), now.getDate(), 4, 0, 0, 0)).toISOString();
        break;
      }
      case "mese": {
        // timestamp = (new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0)).toISOString();
        now.setDate( now.getDate() - 30 );
        timestamp = (new Date(now.getFullYear(), now.getMonth(), now.getDate(), 4, 0, 0, 0)).toISOString();
        break;
      }
      case "anno": {
        now.setDate( now.getDate() - 365 );
        timestamp = (new Date(now.getFullYear(), now.getMonth(), now.getDate(), 4, 0, 0, 0)).toISOString();
        // timestamp = (new Date(now.getFullYear(), 0, 1, 0, 0, 0, 0)).toISOString();
        break;
      }
      default: {
        break;
      }
    }

    return timestamp;

  }

  getDaysOfWeekNames(): Array<string> {
    return this.daysOfWeekNames;
  }

  getMonthsNames(): Array<string> {
    return this.monthNames;
  }

  formatShortDate(date: Date): string {
    return date.getDate() + "/" + (date.getMonth() +1);
  }

  getMonthName(date: Date) {
    return this.monthNames[date.getMonth()];
  }

  getDateStringArrayByLength(length: number) {
    const day = new Date();

    let daysMonth = Array(length).fill("");
    daysMonth.forEach((item, index) => {
      daysMonth[index] = this.formatShortDate(day);
      day.setDate(day.getDate() -1);
    });

    return daysMonth.reverse();
  }

  getMonthsStringArrayByLength(length: number) {
    const day = new Date();

    let months = Array(length).fill("");
    months.forEach((item, index) => {
      months[index] = this.monthNames[day.getMonth()];
      day.setMonth(day.getMonth() -1);
    });

    return months.reverse();
  }

  getMonthsNumberArrayByLength(length: number) {
    const day = new Date();

    let months = Array(length).fill("");
    months.forEach((item, index) => {
      months[index] = day.getMonth();
      day.setMonth(day.getMonth() -1);
    });

    return months.reverse();
  }

  daysDifference(date1: string, date2?: string) {
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const d1 = new Date(date1).getTime();
    const d2 = date2 ? new Date(date2).getTime() : new Date().getTime();
    const diffDays = Math.round((d1 - d2) / oneDay);
    return diffDays;
  }

// ------------------- json utils -----------------------

  addJsonToArray(language: any, title: any, array: { language: any; title: any; }[]) {

    let item = array.find( (X: any) => JSON.parse(JSON.stringify(X)).language == language);
    if(item == null) {
    array.push({"language": language, "title": title});
    }
    return array;
  }

  parseJason(language: any, array: any[]) {
    let item = array.find( (X: any) => JSON.parse(JSON.stringify(X)).language == language);
    let deepClone = JSON.parse(JSON.stringify(item));
    return deepClone.title;
  }

  updateJson(language: any, title: any, array: { language: any; title: any; }[]) {
    let item = array.find( (X: any) => JSON.parse(JSON.stringify(X)).language == language);
    if(item != null) {
      array = array.filter( (X: any) => X != item);
      array.push({"language": language, "title": title});
    }
    return array;
  }

  changeJsonContent(json: any, key: any, value: any){

  }
// ------------------- json utils -----------------------

}
